import { fontType, toRem } from 'shared/styles/functions'
import styled from 'styled-components'

export const GraphContainer = styled.div`
	height: ${toRem(117)};
	${fontType(0)}
`
